import type { Response } from '../../../lib/types/results';

export type ScoreRole = 'winner' | 'nonwinner';

export interface ResponseScoreEntry {
  response: Response;
  avgScore: number;
}

export type ScoreRoleMap = Record<string, ScoreRole>;

export function deriveScoreRoles(entries: ResponseScoreEntry[]): ScoreRoleMap {
  if (!entries || entries.length === 0) {
    return {};
  }

  const sanitizedEntries = entries.map(({ response, avgScore }) => ({
    response,
    avgScore: Number.isFinite(avgScore) ? avgScore : Number.NEGATIVE_INFINITY,
  }));

  const maxScore = sanitizedEntries.reduce((max, entry) => {
    return entry.avgScore > max ? entry.avgScore : max;
  }, Number.NEGATIVE_INFINITY);

  if (!Number.isFinite(maxScore)) {
    return sanitizedEntries.reduce<ScoreRoleMap>((acc, { response }) => {
      acc[response.id] = 'nonwinner';
      return acc;
    }, {});
  }

  return sanitizedEntries.reduce<ScoreRoleMap>((acc, { response, avgScore }) => {
    const isWinner = avgScore === maxScore;
    acc[response.id] = isWinner ? 'winner' : 'nonwinner';
    return acc;
  }, {});
}
